export const parseUsers = (users) => {
  return users
    .map((user, index) => ({
      'key': index,
      'text': user.username,
      'value': user.username,
    }));
};

export const parsePolicies = (policies) => {
  return policies
    .map((policy, index) => ({
      'key': index,
      'text': policy.name,
      'value': policy.id,
    }));
};

const getDealerName = (dealer, dealers) => {
  const dealerObj = dealers.find((dealerInfo) => dealerInfo.identification === dealer);
  return dealerObj?.name || '';
};

const getAgencyName = (agency, agencies) => {
  const agencyObj = agencies.find((agencyInfo) => agencyInfo.code === agency);
  return agencyObj?.name || '';
};

export const parseList = (list, dealers, agencies) => {
  const newList = list.map((element) => {
    const newElement = {
      ...element,
      'dealer': getDealerName(element.dealer, dealers),
      'agency': getAgencyName(element.agency, agencies),
    };
    return newElement;
  });
  return newList;
};

export const parsedDirectoryUsers = (directory) => {
  return directory.map((user, idx) => {
    return {
      'key': user.id,
      'text': user.username,
      'value': user.username?.toUpperCase(),
    };
  });
};
